<template lang="pug">
.theme-picker(v-if="themes", :class="{ shown: roboReportShown && watchlistThemesShown && watchlistShown }")
  .ref-pub-info-wrapper(v-if="refPubInfo", :class="{ shown: refPubInfoShown }")
    .ref-pub-info(:style="refPubInfoStyle", ref="refPubInfo")
      .title(@mousedown="downTitle") {{ refPubInfo.n }}
        .close(@click="refPubInfoShown = false") &times;
      .bg(:style="{ 'background-image': `url('${ refPubInfo.i }'` }")
      .industry {{ refPubInfo.industry }}
      .row
        .ticker {{ refPubInfo.s && refPubInfo.s[0] || '' }}
        .performance(v-if="refPubInfo.performance") {{ (refPubInfo.performance || {}).label }}
          .arrow(:class="{ [(refPubInfo.performance || {}).label]: true }") &#10142;
            .bar
        .no-performance(v-else) &nbsp;
      .theme(v-if="refPubInfo.theme") {{ (refPubInfo.theme.t || refPubInfo.theme.n || '').replace(/ themes/i, '') }}
        .close(@click="watchlistThemesParentFilter = null") &times;
      .charts(v-if="refPubInfo.theme")
        .chart.horse
          .bar(v-for="pub in refPubInfo.theme.ps.sort((a, b) => b.cpr - a.cpr)",
               @click="watchlistThemesRefPub = pub.key",
               :class="{ selected: pub.key === refPubInfo.key }",
               :style="{ width: `${ pub.cpr }%` }")
            .title {{ pub.n }}
            .toggle-robo(@click.stop.capture="toggleSelectedWatchlistPublisher(pub.key)",
                         :class="{ on: publisherSelected(pub.key) }")
              .bars
                .bar.tall.gap
                .bar
                .bar
                .bar.tall
                .bar.gap
                .bar.tall
                .bar
                .bar.tall
                .bar.tall
              .eyes
                .eye
                .eye
        .ariel-view
          //.line(v-for="theme in childThemes.filter(({ cr }) => cr >= 50).sort((a, b) => b.cr - a.cr).filter((item, index) => index < 57)",
          .labels
            .label(v-for="(rating, index) in ['very poorly', 'poorly', 'well', 'very well']",
                   @click="setSentiment(rating, true)",
                   @mouseenter="watchlistThemesHoverRefPubSentiment = rating",
                   @mouseleave="watchlistThemesHoverRefPubSentiment = null",
                   NOTclass="{ on: rating === watchlistThemesRefPubSentiment }",
                   :class="{ on: rating === $store.state.watchlistThemesRefPubSentiment }",
                   :rating="rating")
              //- todo: add an orange dot to the rating that is watchlistThemesRefPubSentiment
          .lines
            .line(v-for="theme in arielViewThemes",
                  :class="{ on: selectedWatchlistThemes[theme.n] }",
                  @click="toggleSelectedWatchlistTheme(theme.n)"
                  :title="theme.t || theme.n")
              .bar(:style="{ width: `${ theme.cr - 50 }%` }", :title="theme.t || theme.n")
                .label {{ theme.t || theme.n }}
              .performance
                .cell(v-for="(rating, index) in ['very poorly', 'poorly', 'well', 'very well']",
                      :title="percentToPerf(theme.ps, index) && rating || ''",
                      :rating="rating",
                      :class="{ on: percentToPerf(theme.ps, index) }")
            .pager(v-if="(importantChildThemes || []).length > itemsPerPage")
              .previous(@click="arielOffset -= itemsPerPage", :style="{ visibility: arielOffset && 'visible' || 'hidden' }") previous
              .next(@click="arielOffset += itemsPerPage", :style="{ visibility: (arielViewThemes || []).length === itemsPerPage  && 'visible' || 'hidden' }") next
        //.scatter(@mousemove="legendMove", @mouseleave="showLegend = false")
        //  .legends(ref="legends", v-if="hoverImportance && hoverPerformance", :style="{ opacity: showLegend && 1 || 0 }")
        //    .legend.performance(:style="{ transform: `translate3d(${ mouseX }px, -100%, 0)` }")
        //      span.label performance:&nbsp;
        //      span.value {{ hoverPerformance }}
        //    .legend.importance(:style="{ transform: `translate3d(0.5rem, ${ mouseY }px, 0)` }")
        //      span.label importance:&nbsp;
        //      span.value {{ hoverImportance }}
        //  .matrix
        //    .cell(v-for="{ importance, performance } in Array.from(new Array(16), (cell, index) => ({ importance: cellImportance(index, 'upper'), performance: cellPerformance(index) }))",
        //      @mouseenter="hoverImportance = importance; hoverPerformance = performance",
        //      :style="{ opacity: percent(importance, performance) && 1 || 0.25 }",
        //      :title="`${ matchesImportance(importance).filter(matchesPerformance(performance)).length }`")
        //      .area
        //        .fill(:style="cellStyle(importance, performance)")
        //  .matrix
        //    .cell(v-for="{ importance, performance } in Array.from(new Array(16), (cell, index) => ({ importance: cellImportance(index, 'lower'), performance: cellPerformance(index) }))",
        //          @mouseenter="hoverImportance = importance; hoverPerformance = performance",
        //          :style="{ opacity: percent(importance, performance) > 0 && 1 || 0.25 }",
        //          :title="`${ matchesImportance(importance).filter(matchesPerformance(performance)).length }`")
        //      .area
        //        .fill(:style="cellStyle(importance, performance)")
      .themes(v-else)
        .theme(v-for="theme in filteredThemes.filter(({ cth }) => cth)", @click="watchlistThemesParentFilter = theme.n") {{ (theme.t || theme.n || '').replace(/ themes/i, '') }}
  .gap-analysis-section(v-if="Object.keys(publishers).length > 1")
    .ref-pub(v-if="refPub", @click="nextPub", @dblclick.stop.prevent.capture="refPubInfoShown = false")
      .favicon(:style="{ 'background-image': `url('${ refPub.i }')` }")
      .exit-gap(@click.stop.prevent.capture="watchlistThemesRefPub = null; watchlistThemesRefPubSwitcher = false") &times;
      .title {{ refPub.n }}
      .switcher
        .chevron(@click.stop.prevent.capture="watchlistThemesRefPubSwitcher = !watchlistThemesRefPubSwitcher", :class="{ on: watchlistThemesRefPubSwitcher }") &#8693;
        .publishers.has-selection(:class="{ shown: watchlistThemesRefPubSwitcher }")
          .close(@click.stop.prevent.capture="watchlistThemesRefPubSwitcher = false;") &times;
          label.filter
            .clearer(:class="{ hidden: !watchlistThemesRefPubSwitcherFilter }", @click="watchlistThemesRefPubSwitcherFilter = ''")
            input(v-model="watchlistThemesRefPubSwitcherFilter", placeholder="filter")
          .sorter(@click.stop.prevent.capture="cycleGapSort",
                  :class="{ 'has-sort': watchlistThemesRefPubSort }",
                  :title="watchlistThemesRefPubSort === 'ascending' && 'low to high' || watchlistThemesRefPubSort === 'descending' && 'high to low' || 'no sort'") sort
            .up-down(v-if="watchlistThemesRefPubSort === 'descending'") &downarrow;
            .up-down(v-if="watchlistThemesRefPubSort === 'ascending'") &uparrow;
          .publisher(v-for="({ n, i, key }) in sortedFilteredRefPubs",
                     @click.stop.prevent="pubSwitcherClick(key)",
                     :key="key",
                     :class="{ on: refPub.n === n }")
            .bg(:style="{ 'background-image': `url('${ i }')` }")
            .title
              .filter-toggle(@click.stop="toggleSelectedWatchlistPublisher(key)", :class="{ selected: selectedWatchlistPublishers[key] }", :title="`filter report by ${ n }`")
              | {{ n }}
          .publisher.clear(@click.stop.prevent.capture="watchlistThemesRefPub = null; watchlistThemesRefPubSwitcher = false")
            .title exit gap analysis &times;
    .gap-analysis(v-else, @click="nextPub") gap analysis
    .gap-analysis-sentiment(v-if="refPub", :class="{ 'has-value': sentiment }")
      .dot(v-for="value in ['very poorly', 'poorly', '', 'well', 'very well']",
           @click="setSentiment(value || null)",
           @mouseenter="watchlistThemesHoverRefPubSentiment = value || null",
           @mouseleave="watchlistThemesHoverRefPubSentiment = null",
           :value="value",
           :title="value || 'no filter'",
           :class="{ on: sentiment === value || (!sentiment && !value) }")
      .label {{ sentiment || 'no filter' }}
      //-.dot(value="very poorly", @click="setSentiment", :class="{ on: sentiment === 'very poorly' }")
      //-.dot(value="poorly", @click="setSentiment", :class="{ on: sentiment === 'poorly' }")
      //-.dot(value="", @click="setSentiment", :class="{ on: sentiment === '' }")
      //-.dot(value="well", @click="setSentiment", :class="{ on: sentiment === '' }")
      //-.dot(value="very well", @click="setSentiment", :class="{ on: sentiment === '' }")
  .selected-watchlist-themes
    .and-or(v-if="Object.keys(selectedWatchlistThemes || {}).length > 1",
            @click="watchlistThemesAndOr = !watchlistThemesAndOr",
            :class="{ on: watchlistThemesAndOr }") {{ watchlistThemesAndOr && 'and' || 'or' }}
    .selected-watchlist-theme(v-for="(v, n) in selectedWatchlistThemes",
                             @click="toggleSelectedWatchlistTheme(n)",
                             :title="themes[n] && themes[n].t || n || ''") {{ themes[n] && themes[n].t || n || '' }}
    .currency-numeric
      .currency(@click="watchlistCurrency = !watchlistCurrency", :class="{ on: watchlistCurrency }") currency
      .numeric(@click="watchlistNumeric = !watchlistNumeric", :class="{ on: watchlistNumeric }") numeric
  //.close(title="close themes", @click="watchlistThemesShown = false") &times;
  .themes
    .theme.no-click
      label
        .clearer(:class="{ hidden: !watchlistThemesFilter }", @click="watchlistThemesFilter = ''")
        input(v-model="watchlistThemesFilter", placeholder="filter")
      .theme-weights.has-value
        .dot(v-for="value in [{ k: 'non-zero', min: 0.0001 }, { k: 'minimal', max: 12.5 }, { k: 'very low', max: 25 }, { k: 'low', max: 37.5 }, { k:'below average', max: 50 }, null, { k:'above average', min: 50 }, { k:'high', min: 62.5 }, { k:'very high', min: 75 }, { k:'maximal', min: 87.5 }]",
             @click="watchlistThemeWeightFilter = value",
             @mouseenter="watchlistThemeWeightHover = value && value.k || 'all'",
             @mouseleave="watchlistThemeWeightHover = null",
             :title="value && value.k || 'all'",
             :class="{ on: (watchlistThemeWeightFilter && watchlistThemeWeightFilter.k) === (value && value.k) || (!value && !watchlistThemeWeightFilter) }")
        .label {{ watchlistThemeWeightHover || watchlistThemeWeightFilter && watchlistThemeWeightFilter.k || 'all' }}
    .theme(v-for="{ n, t, cth, c, cr, ps } in filteredThemes",
           :key="n", :title="`${ t || n }: ${ weight(c) }`",
           @click="toggleSelectedWatchlistTheme(n)",
           :class="{ 'has-bar': cr > 2.5, selected: selectedWatchlistThemes[n], 'has-filter': !!cth }") {{ t || n }}
      .filter-toggle(v-if="!!cth",
                     :title="watchlistThemesParentFilter === n && 'show all' || `only show ${ t || n }`",
                     :class="{ selected: watchlistThemesParentFilter === n }",
                     @click.stop="watchlistThemesParentFilter = watchlistThemesParentFilter !== n && n || ''")
      .stacked-bars(v-if="refPub", :style="{ width: `${ cr }%` }", :class="{ 'has-ref-pub': watchlistThemesRefPub }")
        .stacked-bar(v-for="{ cr, n, i, key } in morphedPS(ps)",
                     title="toggle reference publisher",
                     :class="{ selected: watchlistThemesRefPub === key }"
                     @click.stop="watchlistThemesRefPub = watchlistThemesRefPub !== key && key || null",
                     :style="{ width: `${ cr }%` }",
                     :title="n")
      .bar(v-else, :style="{ width: `${ cr }%` }", :title="t", :cr="cr || 82")
      //.bar(:style="{ width: `${ (weight(c)) * 300 }%` }", :title="t", :cr="cr || 82")
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed } from '@/helpers';
let loadTimer;
let pubSwitcherTimer;
let tooltipTimer;
export default {
  name: 'themePicker',
  data() {
    return {
      maxWeight: 0,
      mouseX: 0,
      mouseY: 0,
      offsetLeft: 0,
      offsetRight: 0,
      hoverImportance: '',
      hoverPerformance: '',
      showLegend: false,
      titleMoving: false,
      titleX: 0,
      titleY: 0,
      arielOffset: 0
    };
  },
  watch: {
    importantChildThemes() {
      this.arielOffset = 0;
    },
    watchlistThemesAndOr() {
      clearTimeout(loadTimer);
      loadTimer = setTimeout(() => this.loadRoboReport('custom'), 700);
    },
    selectedWatchlistThemes() {
      clearTimeout(loadTimer);
      loadTimer = setTimeout(() => this.loadRoboReport('custom'), 700);
    },
    watchlistCurrency() {
      clearTimeout(loadTimer);
      loadTimer = setTimeout(() => this.loadRoboReport('custom'), 700);
    },
    watchlistNumeric() {
      clearTimeout(loadTimer);
      loadTimer = setTimeout(() => this.loadRoboReport('custom'), 700);
    }
  },
  computed: {
    ...mapGetters([
      'genre',
      'lens',
      'doco',
      'themes',
      'selectedWatchlistThemes',
      'analytics',
      'topParentThemes',
      'watchlistShown',
      'watchlistThemesShown',
      'watchlistThemesForPickerMax',
      'filteredWatchlistThemes',
      'roboReportShown',
      'publishers',
      'refPubInfo'
    ]),
    ...vuexComputed(
      'watchlistCurrency',
      'watchlistNumeric',
      'selectedWatchlistPublishers',
      'watchlistThemesParentFilter',
      'watchlistThemesFilter',
      'watchlistThemeWeightFilter',
      'watchlistThemeWeightHover',
      'watchlistThemesRefPub',
      'watchlistThemesRefPubSentiment',
      'watchlistThemesHoverRefPubSentiment',
      'watchlistThemesRefPubSwitcher',
      'watchlistThemesRefPubSwitcherFilter',
      'watchlistThemesRefPubSort',
      'watchlistThemesAndOr',
      'refPubInfoShown',
      'refPubInfoNudge'
    ),
    childThemes() {
      const { filteredThemes, watchlistThemesParentFilter: wtpf, themes } = this;
      let r = [];
      // console.log('childThemes', wtpf);
      if (wtpf && filteredThemes) {
        // console.log('childThemes', wtpf, filteredThemes);
        //const parentThemes = filteredThemes?.filter(({ cth }) => cth);
        // if (parentThemes.length === 1) {
        if (themes && wtpf && themes[wtpf]) {
          const filteredMap = filteredThemes.reduce((map, { n }) => {
            map[n] = true;
            return map;
          }, {});
          // console.log('childThemes', wtpf, parentThemes[0].cth, filteredMap);
          // console.log('childThemes', wtpf, themes[wtpf].cth, filteredMap);
          //r = parentThemes[0].cth
          r = themes[wtpf].cth
            .filter(({ n }) => filteredMap[n])
            .map(({ n, cr }) => {
              return { ...themes[n], cr };
            });
        }
      }
      // console.log('childThemes:', r);
      return r;
    },
    itemsPerPage() {
      const max = 42;
      return ((this.importantChildThemes || []).length === max && max) || max - 1;
    },
    importantChildThemes() {
      const { childThemes, watchlistThemesParentFilter: filter, themes } = this;

      const r = childThemes.filter(({ cr }) => cr >= 50).sort((a, b) => b.cr - a.cr);
      // console.log('crs', childThemes, r.map(({ cr }) => cr));
      // const r = childThemes.filter(th => dynamicCr(th) >= 50).sort((a, b) => dynamicCr(b) - dynamicCr(a));
      // console.log('ict', childThemes, /*themes[filter].cth,*/ childThemes[3].n, childThemes[3] && dynamicCr(childThemes[3]), r);
      return r;
      //return childThemes.filter(th => dynamicCr(th) >= 50).sort((a, b) => dynamicCr(b) - dynamicCr(a));
      function dynamicCr(theme) {
        let r = theme.cr;
        //console.log('dynamicCr', themes);
        if (filter && themes) {
          if (theme.cth) {
            r = 100;
          } else {
            //const { cth } = themes[filter] || {};
            if (theme.index > -1) {
              r = childThemes[theme.index]?.cr || r;
              // r = cth[theme.index]?.cr || r;
            }
            // const { cth } = themes[filter] || {};
            // if (cth && theme.index > -1) {
            //   r = cth.find(({ n }) => n === theme.n)?.cr || r;
            //   // r = cth[theme.index]?.cr || r;
            // }
          }
        }
        return r;
      }
    },
    arielViewThemes() {
      const {
        importantChildThemes: ict,
        arielOffset,
        itemsPerPage,
        watchlistThemesRefPubSentiment: sentiment,
        watchlistThemesHoverRefPubSentiment: hoverSentiment,
        refPub,
        morphedPS
      } = this;
      let r = ict;
      const s = hoverSentiment || sentiment;
      if (s) {
        const cprToRating = cpr => {
          return (
            (cpr <= 25 && 'very poorly') ||
            (cpr <= 50 && 'poorly') ||
            (cpr >= 75 && 'very well') ||
            (cpr >= 50 && 'well')
          );
        };
        // const was = [...r];
        r = r.filter(({ ps }) => {
          // console.log('avt filtering', morphedPS(ps), morphedPS(ps).find(({ n }) => n === refPub.n), refPub);
          return cprToRating(morphedPS(ps).find(({ n }) => n === refPub.n)?.cpr) === s;
        });
        //r = r.filter(({ ps }) => cprToRating(morphedPS(ps)[refPub.n].cpr) === s);
        // console.log('avt', refPub, cprToRating(55), s, was, r);
      }
      return r.filter((item, index) => arielOffset <= index && index < arielOffset + itemsPerPage);
    },
    refPub() {
      const { watchlistThemesRefPub, publishers } = this;
      return publishers[watchlistThemesRefPub];
    },
    refPubInfoStyle() {
      const { refPubInfoNudge: { top, left } } = this;
      return { transform: `translate3d(${ left }px, ${ top }px, 0)` };
    },
    sentiment() {
      return this.watchlistThemesRefPubSentiment;
    },
    filteredThemes() {
      const { filteredWatchlistThemes, morphedPS, sentiment, watchlistThemesRefPub: refPub } = this;
      //console.log('filteredWatchlistThemes', filteredWatchlistThemes);
      // console.log(
      //   'ftt',
      //   (sentiment &&
      //     refPub &&
      //     filteredWatchlistThemes.filter(({ ps, n }) => show(morphedPS(ps).find(({ key }) => key === refPub), n))) ||
      //     filteredWatchlistThemes
      // );
      return (
        (sentiment &&
          refPub &&
          filteredWatchlistThemes.filter(({ ps, n }) => show(morphedPS(ps).find(({ key }) => key === refPub), n))) ||
        filteredWatchlistThemes
      );
      function show(ps, n) {
        const { cpr = 0 } = ps || {};
        //console.log('show ps', ps, cpr, sentiment, refPub, n);
        return (
          ps &&
          {
            'very poorly'() {
              return cpr <= 25;
            },
            poorly() {
              // return cpr <= 50;
              return 25 < cpr && cpr <= 50;
            },
            well() {
              return 50 < cpr && cpr < 75;
            },
            'very well'() {
              return cpr >= 75;
            }
          }[sentiment]()
        );
      }
    },
    parentThemes() {
      const { topParentThemes, themes } = this;
      // console.log('computed themes', topParentThemes, (selectedVis === 'selectedThemes' && Object.keys(selectedThemes) || topParentThemes)
      //   .filter(n => themes[n])
      //   .map(n => themes[n]));
      return topParentThemes.map(([n]) => n)
        .filter(n => themes[n])
        .map(n => themes[n]);
    },
    sortedFilteredRefPubs() {
      const { filteredRefPubs, watchlistThemesRefPubSort: sort, filteredThemes: themes, morphedPS, watchlistThemesParentFilter: parentTheme } = this;
      let r = Object.entries(filteredRefPubs).map(([key, value]) => ({ key, ...value }));
      if (sort) {
        const t = themes.map(({ ps }) => morphedPS(ps));
        if (parentTheme) {
          const { ps } = themes.find(({ n }) => n === parentTheme) || {};
          // console.log('parent theme', parentTheme);
          const mps = morphedPS(ps);
          // console.log('morphed', mps);
          r.forEach(pub => {
            pub.sortWeight = (mps.find(({ key }) => key === pub.key) || { cr: 0 }).cr;
          });
        } else {
          const tally = t.reduce((tally, ps) => {
            ps.forEach(({ key, cr }) => {
              tally[key] = tally[key] || 0;
              tally[key] += cr;
            });
            return tally;
          }, {});
          r.forEach(pub => {
            pub.sortWeight = tally[pub.key];
          });
        }
        r.sort((a, b) => {
          let r = a.sortWeight - b.sortWeight;
          return (sort === 'ascending' && r) || b.sortWeight - a.sortWeight;
        });
      }
      // console.log('sortedFilteredRefPubs', r);
      return r;
    },
    filteredRefPubs() {
      const { publishers, watchlistThemesRefPubSwitcherFilter } = this;
      return Object.entries(publishers)
        .filter(([_, { n, s }]) => testPub(n, s))
        .reduce((map, [key, pub]) => {
          map[key] = pub;
          return map;
        }, {});
      function testPub(n, s) {
        const searchText = `${ n }|${ (s || []).join('|') }`;
        return !watchlistThemesRefPubSwitcherFilter || watchlistThemesRefPubSwitcherFilter.split(/\s+/).every(testWord);
        function testWord(word) {
          const tester = new RegExp(escapeRegExp(word), 'i');
          return tester.test(searchText);
        }
      }
      function escapeRegExpAndBound(s) {
        return `\\b${ escapeRegExp(s) }\\b`; // $& means the whole matched string
      }
      function escapeRegExp(s) {
        return `${ s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }`; // $& means the whole matched string
      }
    }
  },
  methods: {
    ...mapActions(['toggleSelectedWatchlistTheme', 'toggleSelectedWatchlistPublisher', 'loadRoboReport']),
    percentToPerf(ps, index) {
      const { morphedPS, refPubInfo } = this;
      const value = morphedPS(ps).find(({ key }) => key === refPubInfo.key).cpr;
      return [
        value => value <= 25,
        value => 25 < value && value <= 50,
        value => 50 < value && value < 75,
        value => value >= 75
      ][index](value);
      // const min = index * 25;
      // const max = min + 25;
      // return min < value && value < max;
      // return min < value && value <= max;
    },
    publisherSelected(publisher) {
      const { selectedWatchlistPublishers } = this;
      const length = Object.keys(selectedWatchlistPublishers).length;
      return !length || selectedWatchlistPublishers[publisher];
    },
    downTitle(e) {
      const { $refs: { refPubInfo }, refPubInfoNudge: { top, left }, $el } = this;
      const { clientX, clientY } = e;
      const nudge = (left, top) => this.refPubInfoNudge = { left, top };
      //style.transform = `translate3d(1px, 1px, 0)`;
      const handlers = {
        move(e) {
          console.log('move', left + clientX - e.clientX);
          nudge(left + e.clientX - clientX, top + e.clientY - clientY);
        },
        up() {
          console.log('up1', $el || 'huh?');
          $el.removeEventListener('mousemove', handlers.move);
          $el.removeEventListener('mouseup', handlers.up);
          console.log('up2');
        }
      };
      $el.addEventListener('mousemove', handlers.move);
      $el.addEventListener('mouseup', handlers.up);
    },
    titleDown({ clientX, clientY }) {
      console.log('titleDown');
      this.titleMoving = true;
      this.titleX = clientX;
      this.titleY = clientY;
      document.body.addEventListener('mousemove', this.titleMove);
      document.body.addEventListener('mouseup', this.titleUp);
    },
    titleUp() {
      console.log('titleUp');
      this.titleMoving = false;
      document.body.removeEventListener('mousemove', this.titleMove);
      document.body.removeEventListener('mouseup', this.titleUp);
    },
    titleMove({ clientX, clientY }) {
      if (this.titleMoving) {
        // const { refPubInfoNudge: { top: nudgeTop, left: nudgeLeft },  } = this;
        const { titleX, titleY } = this;
        const [x, y] = [clientX - titleX, clientY - titleY];
        console.log('mousemove', x, y);
        this.refPubInfoNudge = { top: y, left: x };
      }
    },
    legendMove({ clientX, clientY }) {
      const { offsetLeft, offsetTop, $refs: { legends } } = this;
      if (legends) {
        const { top, left } = offsetLeft && { top: offsetTop, left: offsetLeft } || legends.getBoundingClientRect();
        const [x, y] = [clientX - left, clientY - top];
        //console.log('mousemove', x, y);
        clearTimeout(tooltipTimer);
        tooltipTimer = setTimeout(() => {
          this.showLegend = false;
        }, 50);
        window.requestAnimationFrame(() => {
          this.mouseX = x;
          this.mouseY = y;
          clearTimeout(tooltipTimer);
          tooltipTimer = setTimeout(() => {
            this.showLegend = true;
          }, 250);
        });
      }
    },
    setSentiment(value, toggle) {
      const { $store: { state: { watchlistThemesRefPubSentiment: wtrps } } } = this;
      // console.log('setSentiment', value, toggle, wtrps !== value, (!toggle || wtrps !== value) && value || null);
      this.watchlistThemesRefPubSentiment = (!toggle || wtrps !== value) && value || null;
    },
    cycleGapSort() {
      const { watchlistThemesRefPubSort } = this;
      this.watchlistThemesRefPubSort = !watchlistThemesRefPubSort && 'ascending' || watchlistThemesRefPubSort === 'ascending' && 'descending' || null;
    },
    nextPub() {
      const { watchlistThemesRefPub, publishers } = this;
      const keys = Object.keys(publishers);
      const index = keys.indexOf(watchlistThemesRefPub);
      this.watchlistThemesRefPub = (index === -1 && keys[0]) || keys[index + 1] || null;
    },
    pubSwitcherClick(key) {
      this.watchlistThemesRefPub = key;
      clearTimeout(pubSwitcherTimer);
      pubSwitcherTimer = setTimeout(() => this.watchlistThemesRefPubSwitcher = false, 250);
    },
    morphedPS(ps) {
      //const pt = this.analytics.thd.pt;
      const { analytics: { thd: { pt } }, publishers } = this;
      //console.log('morphedPS index', Object.entries(ps));
      const r = Object.entries(ps || {}).reduce((all, [i, v]) => {
        const key = pt[i];
        all.push({ ...(publishers[key] || {}), key, ...(v || {}) });
        return all;
      }, []).sort((a, b) => a.cr - b.cr);
      // console.log('morphedPS', r);
      return r;
    },
    hasFilter(n) {
      return !!this.themes?.[n]?.cth;
    },
    weight(c) {
      return (c / this.watchlistThemesForPickerMax).toPrecision(2);
    },
    oldWeight(n) {
      const { analytics: { thd: { tht } }, maxWeight } = this;
      const r = Object.values(tht[n]?.pwt || {}).reduce((total, { pgr }) => total + (pgr || 0), 0) || 0;
      if (r > maxWeight) {
        this.maxWeight = r;
      }
      return r;
    },
    cellStyle(importance, performance) {
      const percent = Math.ceil(this.percent(importance, performance) / 10) * 10;
      return { height: `${ percent }%` };
    },
    percent(importance, performance) {
      const { filteredThemes, matchesImportance, matchesPerformance } = this;
      // console.log(importance, performance);
      //"value in [{ k: 'non-zero', min: 0.0001 }, { k: 'minimal', max: 12.5 }, { k: 'very low', max: 25 }, { k: 'low', max: 37.5 }, { k:'below average', max: 50 }, null, { k:'above average', min: 50 }, { k:'high', min: 62.5 }, { k:'very high', min: 75 }, { k:'maximal', min: 87.5 }]"
      const count = matchesImportance(importance).filter(matchesPerformance(performance)).length;
      // console.log('cellStyle', filteredThemes.length, importance, count);
      const ratio = count / filteredThemes.length;
      const percent = ratio * 100;
      return count && percent || 0;
    },
    matchesPerformance(performance) {
      const performances = {
        'very poorly'(value) {
          return value <= 25;
        },
        poorly(value) {
          return value <= 50;
        },
        well(value) {
          return value >= 50;
        },
        'very well'(value) {
          return value >= 75;
        }
      };
      const cpr = ({ ps }) => {
        const { morphedPS, refPubInfo } = this;
        const mps = morphedPS(ps);
        return mps.find(({ key }) => key === refPubInfo.key)?.cpr || 0;
      };
      return theme => performances[performance](cpr(theme));
    },
    matchesImportance(importance) {
      const { filteredThemes } = this;
      const importances = {
        minimal(value) {
          return value < 12.5;
        },
        'very low'(value) {
          return value < 25;
        },
        low(value) {
          return value < 37.5;
        },
        'below average'(value) {
          return value < 50;
        },
        'above average'(value) {
          return value >= 50;
        },
        'high'(value) {
          return value > 62.5;
        },
        'very high'(value) {
          return value > 75;
        },
        'maximal'(value) {
          return value > 87.5;
        }
      };
      return filteredThemes.filter(({ cr }) => importances[importance](cr));
    },
    cellPerformance(index) {
      return ['very poorly', 'poorly', 'well', 'very well'][index % 4];
    },
    cellImportance(index, region) {
      return {
        upper: ['maximal', 'very high', 'high', 'above average'],
        lower: ['below average', 'low', 'very low', 'minimal']
      }[region][Math.floor(index / 4)];
    }
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.theme-picker {
  position: fixed;
  top: 6rem;
  left: 49vw;
  margin-left: 0.125rem;
  padding: 2.25rem 1rem 1rem;
  //margin-left: 1rem;
  background-color: white;
  border: 1px solid $brn;
  border-top-width: 0;
  border-left-width: 0;
  box-sizing: border-box;
  width: 51vw;
  //max-height: calc(100vh - 6rem);
  z-index: 1;
  transform: translate3d(150vw, 0, 0);
  opacity: 0;
  pointer-events: none;
  transition: all 250ms ease-in-out;
  will-change: transform;
  font-family: Assistant, Roboto, sans-serif;
  //&:not(&.shown) * {
  //  pointer-events: none !important;
  //}
  &.shown {
    pointer-events: all;
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  .close {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    cursor: pointer;
  }
  .ref-pub-info-wrapper {
    pointer-events: none;
    position: fixed;
    left: 0;
    top: 9rem;
    transform: translate3d(-150vw, 0, 0);
    transition: transform 600ms ease-in-out;
    z-index: 17000;
    &.shown {
      transform: translate3d(-75%, 0, 0);
    }
    .ref-pub-info {
      cursor: default;
      pointer-events: all;
      user-select: none;
      min-width: 42vw;
      min-height: 40rem;
      background-color: white;
      border: 4px solid orange;
      box-shadow: 1px 1px 3px orange;
      box-sizing: border-box;
      border-radius: 0.5rem;
      padding: 4.9rem 4rem 0.5rem 10rem;
      text-align: left;
      overflow: hidden;
      color: $brn;
      & > .title {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        //transform: translate3d(-50%, 0, 0);
        font-size: 4rem;
        text-align: center;
        background-color: orange;
        color: white;
        text-shadow: 0 0 2px black;
        font-weight: 700;
        font-family: Assistant, Roboto, sans-serif;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-bottom: 2rem solid orange;
        box-sizing: border-box;
        & > .close {
          top: -0.5rem;
          right: 0.25rem;
          transform-origin: top right;
          transform: scale(0.5);
        }
      }
      & > .bg {
        background: white center no-repeat;
        background-size: contain;
        position: absolute;
        top: 4.5rem;
        left: 0.5rem;
        width: 8rem;
        height: 8rem;
        border-radius: 0.5rem;
        //border-top-left-radius: 0.5rem;
        //border-bottom-left-radius: 0.5rem;
      }
      & > .industry {
        position: absolute;
        bottom: 0.5rem;
        left: 0.5rem;
      }
      & > .theme {
        position: relative;
        left: -1rem;
        margin-top: 1rem;
        margin-right: 14.5rem;
        font-size: 2.5rem;
        white-space: nowrap;
        max-width: 29rem;
        //width: rem;
        z-index: 2;
        & > .close {
          top: -1rem;
          right: -19.25rem;
          transform: scale(0.6);
          color: #ccc;
          &:hover {
            color: black;
          }
        }
      }
      & > .row {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 0.5rem;
        z-index: 1;
        & > .ticker {
          color: white;
          z-index: 1;
          font-weight: 700;
          transform: translate3d(0, 1px, 0);
          &::before {
            content: 'ticker: ';
            font-weight: 400;
            //color: #ccc;
          }
        }
        & > .performance {
          position: relative;
          text-align: right;
          padding-right: 2rem;
          color: white;
          font-weight: 700;
          transform: translate3d(3.75rem, 1px, 0);
          &::before {
            content: 'performance: ';
            font-weight: 400;
            //color: #ccc;
          }
          & > .arrow {
            position: absolute;
            top: -0.7rem;
            right: -0.5rem;
            transform-origin: center;
            transform: rotate(90deg);
            color: white;
            &.good {
              transform: rotate(-90deg);
            }
            text-align: center;
            font-size: 2rem;
            padding: 0.25rem;
            &::after {
              content: '\00a0';
              position: absolute;
              top: 25%;
              left: 0;
              bottom: 20%;
              right: 0;
              border: 2px solid white;
              border-radius: 0.25rem;
              z-index: -1;
              background-color: orange;
            }
            &:not(.very) {
              & > .bar {
                background-color: orange;
              }
            }
            & > .bar {
              position: absolute;
              top: 30%;
              left: 23%;
              width: 17%;
              bottom: 30%;
            }
          }
        }
      }
      & > .themes {
        margin-top: 1.5rem;
      }
      & > .charts {
        & > .chart {
          position: absolute;
          top: 13.5rem;
          left: 2rem;
          font-family: Assistant, Roboto, sans-serif;
          width: 50%;
          margin-right: 5rem;
          > .bar {
            cursor: pointer;
            position: relative;
            font-size: 0.8rem;
            height: 0.25rem;
            background-color: #ccc;
            margin-bottom: 0.9rem;
            transition: transform 250ms ease-in-out;
            transform-origin: center;
            &.selected {
              background-color: orange;
              font-weight: 700;
              font-size: 1.2rem;
            }
            &:hover {
              //transform: scale(1.1);
              & > .title {
                color: black;
              }
            }
            & > .title {
              position: absolute;
              left: 100%;
              top: 0;
              transform: translate3d(0.5rem, -50%, 0);
              white-space: nowrap;
            }
            & > .toggle-robo {
              top: 0;
              left: 0;
              transform: translate3d(-1.5rem, -50%, 0) scale(0.75);
              transform-origin: left center;
              width: 1.25rem;
              height: 1.25rem;
              z-index: 4;
              background-color: $brn;
              border-radius: 0.25rem;
              overflow: hidden;
              opacity: 0.25;
              transition: opacity 250ms ease-in-out;
              &:hover,
              &.on {
                opacity: 1;
              }
              .eyes {
                position: absolute;
                top: 0.25rem;
                left: 0;
                right: 0;
                display: flex;
                justify-content: space-evenly;
                .eye {
                  width: 0.25rem;
                  height: 0.25rem;
                  background-color: white;
                  border: 1px solid #282828;
                  border-radius: 50%;
                  & + .eye {
                    background-color: orange;
                  }
                }
              }
              > .bars {
                position: absolute;
                width: 50%;
                left: 50%;
                > .bar {
                  padding-top: 0;
                  height: 1px;
                  background-color: white;
                  margin-top: 1px;
                  &.tall {
                    height: 2px;
                  }
                  &.gap {
                    margin-bottom: 2px;
                  }
                }
              }
            }
          }
        }
        & > .ariel-view {
          $cellWidth: 1.75rem;
          $cellPerfWidth: $cellWidth * 4;
          position: absolute;
          top: 14.75rem;
          bottom: 0.25rem;
          transform: translate3d(0, -5rem, 0);
          //overflow-y: auto;
          //overflow-x: visible;
          width: 22%;
          right: 0;
          display: grid;
          grid-template-rows: repeat(300, 1fr);
          $line-height: 0.6rem;
          &::before {
            position: fixed;
            top: -1.5rem;
            left: -5.5rem;
            content: 'performance';
            font-size: 0.8rem;
          }
          &::after {
            position: fixed;
            top: 7.5rem;
            left: -9.5rem;
            content: 'importance';
            font-size: 0.8rem;
            transform: rotate(-90deg);
          }
          .labels {
            position: absolute;
            top: 0;
            right: 0.5rem;
            width: $cellPerfWidth;
            display: grid;
            grid-template-columns: repeat(4, $cellWidth);
            .label {
              cursor: pointer;
              position: relative;
              //&:hover,
              &.on {
                color: black;
              }
              &::after {
                content: attr(rating);
                position: absolute;
                top: -1.7rem;
                left: 50%;
                transform: translate3d(-50%, 0, 0) rotate(45deg);
                font-size: 0.6rem;
                white-space: nowrap;
              }
            }
          }
          .lines {
            //overflow-y: auto;
            position: absolute;
            top: -2.5rem;
            right: -4.5rem;
            bottom: 0;
            width: 25%;
            box-sizing: border-box;
            padding-top: 2.5rem;
            .pager {
              position: absolute;
              top: 100%;
              right: 3.25rem;
              margin-top: 4.4rem;
              display: grid;
              grid-template-columns: repeat(2, 3rem);
              .previous,
              .next {
                cursor: pointer;
                font-size: 0.6rem;
                text-transform: uppercase;
              }
            }
          }
          .line {
            cursor: pointer;
            position: relative;
            left: -5rem;
            height: $line-height;
            margin-bottom: 1.75px;
            //&:first-of-type {
            //  .performance {
            //    .cell {
            //      &::after {
            //        content: attr(rating);
            //        position: absolute;
            //        top: -1.7rem;
            //        left: 50%;
            //        transform: translate3d(-50%, 0, 0) rotate(45deg);
            //        font-size: 0.6rem;
            //        white-space: nowrap;
            //      }
            //    }
            //  }
            //  //transform: translate3d(2rem, 0, 0);
            //}
            &.on {
              & > .bar {
                background-color: $brn;
              }
            }
            .performance {
              position: absolute;
              top: 0;
              //left: -$cellPerfWidth;
              right: 0;
              width: $cellPerfWidth;
              box-sizing: border-box;
              //padding-right: $line-height * 2;
              display: grid;
              grid-template-columns: repeat(4, 1fr);
              //grid-column-gap: 1px;
              .cell {
                position: relative;
                top: $line-height / 3.5;
                background-color: #eee;
                height: $line-height / 5;
                &.on {
                  top: 0;
                  border-top: none;
                  border-radius: 2px;
                  background-color: orange;
                  height: $line-height * 0.8;
                  //transform: translate3d(0, $line-height / 2, 0);
                }
              }
            }
            > .bar {
              position: absolute;
              right: $cellPerfWidth + 6rem;
              top: $line-height * 0.1;
              height: $line-height * 0.8;
              background-color: #dadada;
              border-top-left-radius: $line-height / 2;
              border-bottom-left-radius: $line-height / 2;
              &::after {
                content: attr(title);
                position: absolute;
                top: -0.175rem;
                right: -6.1rem;
                width: 6rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 0.7rem;
                color: $brn;
              }
              .label {
                display: none;
                position: absolute;
                top: 0;
                left: 5rem;
                white-space: nowrap;
              }
              .performance {
                position: absolute;
                top: 0;
                $cellWidth: 0.5rem;
                $cellPerfWidth: $cellWidth * 4;
                left: -$cellPerfWidth;
                width: $cellPerfWidth;
                box-sizing: border-box;
                padding-right: $line-height * 2;
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                //grid-column-gap: 1px;
                .cell {
                  position: relative;
                  top: $line-height / 3.5;
                  background-color: #eee;
                  height: $line-height / 4;
                  &.on {
                    top: 0;
                    border-top: none;
                    border-radius: 2px;
                    background-color: orange;
                    height: $line-height;
                    //transform: translate3d(0, $line-height / 2, 0);
                  }
                }
              }
            }
          }
        }
        & > .scatter {
          position: absolute;
          left: 0.5rem;
          top: 13.5rem;
          width: 8rem;
          height: 13.5rem;
          //background-color: orange;
          box-sizing: border-box;
          border-radius: 0.5rem;
          //border: 2px solid #eee;
          display: grid;
          grid-template-rows: repeat(2, 1fr);
          grid-row-gap: 0.125rem;
          & > .legends {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 1;
            pointer-events: none;
            transition: opacity 250ms ease-in-out;
            & > .legend {
              position: absolute;
              white-space: nowrap;
              padding: 0.25rem 0.75rem;
              background-color: white;
              border: 1px solid $brn;
              border-radius: 0.25rem;
              box-shadow: 1px 1px 2px rgba($brn, 0.5);
              will-change: transform;
              &.performance {
                top: -0.5rem;
                left: 0;
                //transform: translate3d(0, -200%, 0);
              }
              &.importance {
                top: 0;
                left: 100%;
                //transform: translate3d(-100%, 0, 0);
              }
              span.label {
                color: #bbb;
              }
            }
          }
          & > .matrix {
            display: grid;
            grid-template-columns: repeat(4, 1.75rem);
            //grid-template-columns: repeat(4, 0.75rem);
            grid-template-rows: repeat(4, 1.37rem);
            grid-gap: 0.25rem;
            &:first-of-type {
              & > :first-of-type {
                //background: $brn;
                border-top-left-radius: 0.5rem;
              }
              & > :nth-of-type(4) {
                //background: $brn;
                border-top-right-radius: 0.5rem;
              }
              .area > .fill {
                bottom: 0;
              }
            }
            &:last-of-type {
              & > :last-of-type {
                //background: $brn;
                border-bottom-right-radius: 0.5rem;
              }
              & > :nth-of-type(13) {
                //background: $brn;
                border-bottom-left-radius: 0.5rem;
              }
              .area > .fill {
                top: 0;
              }
            }
            & > .cell {
              position: relative;
              //background: $brn;
              box-sizing: border-box;
              border: 1px solid #ccc;
              padding: 0.25rem;
              padding-top: 0.25rem;
              padding-left: 0.3rem;
              padding-left: 0.3rem;
              //grid-gap: 1px;
              //overflow: hidden;
              background-color: #e5e5e5;
              &:first-of-type,
              &:nth-of-type(2),
              &:nth-of-type(3),
              &:nth-of-type(4) {
                border-top-color: transparent;
              }
              &:first-of-type,
              &:nth-of-type(5),
              &:nth-of-type(9),
              &:nth-of-type(13) {
                border-left-color: transparent;
              }
              &:nth-of-type(4),
              &:nth-of-type(8),
              &:nth-of-type(12),
              &:nth-of-type(16) {
                border-right-color: transparent;
              }
              &:nth-of-type(13),
              &:nth-of-type(14),
              &:nth-of-type(15),
              &:nth-of-type(16) {
                border-bottom-color: transparent;
              }
              .area {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                .fill {
                  max-height: 100%;
                  background-color: $brn;
                  position: absolute;
                  left: 0;
                  right: 0;
                  height: 50%;
                }
              }
            }
          }
        }
      }
    }
  }
  .gap-analysis {
    cursor: pointer;
    position: absolute;
    top: 2.65rem;
    right: 19rem;
    box-sizing: border-box;
    padding: 0.125rem 0.5rem;
    border-radius: 0.125rem;
    border: 1px solid transparent;
    z-index: 2;
    font-family: Assistant, Roboto, sans-serif;
    font-weight: 400;
    font-size: 0.7rem;
    text-transform: uppercase;
    color: #989898;
    transition: all 250ms ease-in-out;
    &:hover {
      color: $brn;
      border-color: rgba($brn, 0.6);
    }
  }
  .gap-analysis-sentiment {
    //cursor: pointer;
    position: absolute;
    top: 2.665rem;
    right: 13.75rem;
    box-sizing: border-box;
    padding: 0.35rem 0.5rem;
    border-radius: 0.125rem;
    border: 1px solid transparent;
    z-index: 2;
    font-family: Assistant, Roboto, sans-serif;
    font-weight: 400;
    font-size: 0.7rem;
    text-transform: uppercase;
    transition: all 250ms ease-in-out;
    display: grid;
    grid-template-columns: repeat(5, 0.35rem);
    grid-column-gap: 0.25rem;
    &:not(.has-value):hover {
      border-color: rgba($brn, 0.6);
    }
    &.has-value,
    &:hover {
      & > .label {
        opacity: 1;
      }
    }
    & > .dot {
      cursor: pointer;
      background-color: #dadada;
      padding-top: 100%;
      border-radius: 50%;
      transition: all 250ms ease-in-out;
      &:hover,
      &.on {
        background-color: $brn;
      }
    }
    & > .label {
      pointer-events: none;
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translate3d(-50%, 0.125rem, 0);
      white-space: nowrap;
      opacity: 0;
      transition: opacity 250ms ease-in-out;
    }
  }
  .ref-pub {
    cursor: pointer;
    position: absolute;
    top: 2.35rem;
    right: 19rem;
    z-index: 2;

    &:hover {
      .title {
        opacity: 1;
      }
      .exit-gap {
        opacity: 1;
        pointer-events: all;
      }
    }
    & > .favicon {
      width: 1.75rem;
      height: 1.75rem;
      background: no-repeat center;
      background-size: contain;
    }
    & > .exit-gap {
      pointer-events: none;
      position: absolute;
      top: -0.125rem;
      right: 1.5rem;
      width: 2rem;
      height: 2rem;
      transition: opacity 250ms ease-in-out;
      opacity: 0;
    }
    & > .title {
      position: absolute;
      right: 100%;
      top: 50%;
      box-sizing: border-box;
      padding: 0 1rem 0 0.125rem;
      white-space: nowrap;
      color: $brn;
      font-family: Assistant, Roboto, sans-serif;
      font-weight: 400;
      font-size: 0.8rem;
      text-transform: uppercase;
      transform: translate3d(0, -50%, 0);
      transition: opacity 250ms ease-in-out;
      pointer-events: none;
      opacity: 0;
    }
    .switcher {
      position: absolute;
      top: 0;
      right: 0;
      width: 17rem;
      .chevron {
        cursor: pointer;
        position: absolute;
        top: 0.25rem;
        right: -1.125rem;
        opacity: 0.5;
        transition: opacity 250ms ease-in-out;
        &:hover,
        &.on {
          opacity: 1;
        }
      }
      .publishers {
        position: absolute;
        top: 100%;
        right: -1.5rem;
        margin-top: 2rem;
        width: 18rem;
        //display: flex;
        //grid-auto-columns: 20%;
        display: grid;
        //justify-content: flex-start;
        grid-template-columns: 1fr;
        grid-column-gap: 0.125rem;
        grid-row-gap: 1.5rem;
        box-sizing: border-box;
        padding: 0.5rem 0.5rem 1.5rem 5.25rem;
        padding-top: 2rem;
        pointer-events: none;
        opacity: 0;
        transition: all 250ms ease-in-out;
        //max-height: 0;
        //overflow: hidden;
        background-color: white;
        //border: 1px solid transparent;
        border: 1px solid #dadada;
        border-radius: 0.25rem;
        max-height: 90vh;
        overflow: auto;
        //border-color: #dadada;
        & > .close {
          cursor: pointer;
          position: absolute;
          top: 0.125rem;
          right: 0.25rem;
          color: #8a8a8a;
          &:hover {
            color: black;
          }
        }
        & > .sorter {
          position: absolute;
          top: 0.5rem;
          left: 14.5rem;
          font-size: 0.7rem;
          color: #aaa;
          &.has-sort {
            color: $brn;
          }
          & > .up-down {
            position: absolute;
            top: 50%;
            left: 100%;
            transform: translate3d(0.25rem, -50%, 0);
            color: $brn;
          }
        }
        & > label.filter {
          position: absolute;
          top: 0.25rem;
          left: 5rem;
          input {
            width: 9rem;
            line-height: 1.4rem;
            color: $brn;
            border: 1px solid #efefef;
            &:focus {
              border-color: #9a9a9a;
              outline: none;
            }
          }
        }
        &.has-overflow:hover {
          max-height: 100vh;
          border-color: #dadada;
        }
        &.shown {
          pointer-events: all;
          opacity: 1;
        }
        &::before {
          position: absolute;
          top: 0.5rem;
          left: 0.25rem;
          content: 'publishers:';
          color: $brn;
          text-transform: capitalize;
          font-family: Assistant, Roboto, sans-serif;
          font-weight: 400;
          font-size: 0.9rem;
        }
        &.has-selection {
          & > .publisher {
            &.on {
              opacity: 1;
              &::after {
                opacity: 1;
              }
            }
          }
        }
        & > .publisher {
          cursor: pointer;
          //width: 1.25rem;
          height: 1.25rem;
          position: relative;
          //margin: 0 0.125rem;
          //opacity: 0.5;
          &.clear {
            transform: translate3d(-0.125rem, 1rem, 0);
            opacity: 0.5;
            color: $brn;
          }
          &.on {
            opacity: 1;
            & > .title {
              opacity: 1;
            }
            &::after {
              opacity: 0;
            }
          }
          &:hover {
            opacity: 1;
            & > .title > .filter-toggle {
              opacity: 0.5;
            }
          }
          & > .bg {
            position: absolute;
            top: 0;
            right: 1rem;
            width: 1.25rem;
            height: 1.25rem;
            //bottom: 0;
            //right: 0;
            background: white center no-repeat;
            background-size: contain;
          }
          &:not(.clear) {
            & > .title {
              padding-right: 2.75rem;
            }
            &::after {
              content: '';
              position: absolute;
              top: 50%;
              right: 0;
              transform: translate3d(0, -50%, 0);
              width: 0.45rem;
              height: 0.45rem;
              background-color: orange;
              border-radius: 0.125rem;
              opacity: 0;
              transition: opacity 250ms ease-in-out;
            }
          }
          & > .title {
            text-align: right;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            opacity: 0.7;
            & > .filter-toggle {
              //position: absolute;
              //top: 0.3rem;
              //left: -5rem;
              pointer-events: all;
              position: relative;
              top: 0.275rem;
              display: inline-block;
              width: 1.2rem;
              height: 1.2rem;
              background: no-repeat center
                url("data:image/svg+xml;charset%3Dutf8,%3C?xml version%3D'1.0' encoding%3D'UTF-8'?%3E%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'-2 -256 1792 1792'%3E%3Cg transform%3D'matrix(1,0,0,-1,182.23729,1201.8983)'%3E%3Cpath style%3D'fill:orange' d%3D'm 1403,1241 q 17,-41 -14,-70 L 896,678 V -64 q 0,-42 -39,-59 -13,-5 -25,-5 -27,0 -45,19 L 531,147 q -19,19 -19,45 V 678 L 19,1171 q -31,29 -14,70 17,39 59,39 h 1280 q 42,0 59,-39 z'/%3E  %3C/g%3E%3C/svg%3E");
              background-size: 75%;
              opacity: 0;
              transition: opacity 250ms ease-in-out;
              will-change: opacity;
              &:hover,
              &.selected {
                opacity: 1;
              }
            }
          }
        }
      }
    }
  }
  .selected-watchlist-themes {
    font-family: Assistant, Roboto, sans-serif;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding-left: 3.25rem;
    padding-right: 12.5rem;
    min-height: 2rem;
    position: relative;
    & * {
      user-select: none;
    }
    & > .and-or {
      cursor: pointer;
      position: absolute;
      top: 0.35rem;
      left: 0.75rem;
      color: $brn;
      border: 1px solid rgba($brn, 0.5);
      border-radius: 0.25rem;
      width: 2.25rem;
      font-size: 0.8rem;
      font-family: Assistant, Roboto, sans-serif;
      text-transform: uppercase;
      text-align: center;
      opacity: 0.5;
      transition: opacity 250ms ease-in-out;
      &.on,
      &:hover {
        opacity: 1;
      }
    }
    .currency-numeric {
      display: flex;
      position: absolute;
      right: 1rem;
      top: 50%;
      transform: translate3d(0, -50%, 0);
      .currency,
      .numeric {
        cursor: pointer;
        user-select: none;
        box-sizing: border-box;
        width: 5rem;
        text-align: center;
        padding: 0.125rem 0.5rem;
        border: 1px solid #dadada;
        border-radius: 0.125rem;
        margin-left: 0.5rem;
        font-family: Assistant, Roboto, sans-serif;
        font-weight: 400;
        font-size: 0.7rem;
        text-transform: uppercase;
        color: $brn;
        background-color: white;
        transition: all 250ms ease-in-out;
        &.on {
          font-weight: 600;
          color: white;
          background-color: $brn;
          border-color: $brn;
        }
      }
    }
    .selected-watchlist-theme {
      cursor: pointer;
      font-size: 0.8rem;
      flex: none;
      margin: 0.25rem;
      padding: 0.25rem 0.5rem;
      padding-right: 1rem;
      border-radius: 0.125rem;
      background: $brn;
      color: white;
      position: relative;
      max-width: 6rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      &:hover {
        &::after {
          content: '\00d7';
          position: absolute;
          top: 0.25rem;
          right: 0.25rem;
        }
      }
    }
  }
  .themes {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 0.25rem;
    overflow: auto;
    max-height: calc(100vh - 12rem);
    cursor: pointer;
    padding: 0.25rem 0.75rem;
    .theme {
      text-align: left;
      font-size: 0.85rem;
      font-weight: 600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      position: relative;
      $bar-height: 0.25rem;
      padding: 1.5 * $bar-height 0.25rem 1.5 * $bar-height;
      border: 1px solid transparent;
      transition: transform 250ms ease-in-out;
      background-color: white;
      transform: rotate(0);
      //will-change: border-color;
      &.no-click {
        position: relative;
        label {
          position: relative;
          input {
            line-height: 1.4rem;
            color: #8d6e4f;
            border: 1px solid #efefef;
            width: 8.5rem;
            &:focus {
              border-color: #9a9a9a;
              outline: none;
            }
          }
        }
        .theme-weights {
          //cursor: pointer;
          position: absolute;
          top: 0.25rem;
          right: 0.75rem;
          box-sizing: border-box;
          padding: 0.35rem 0.5rem;
          border-radius: 0.125rem;
          border: 1px solid transparent;
          z-index: 2;
          font-family: Assistant, Roboto, sans-serif;
          font-weight: 400;
          font-size: 0.7rem;
          text-transform: uppercase;
          transition: all 250ms ease-in-out;
          display: grid;
          grid-template-columns: repeat(10, 0.35rem);
          grid-column-gap: 0.25rem;
          &:not(.has-value):hover {
            border-color: rgba($brn, 0.6);
          }
          &.has-value,
          &:hover {
            & > .label {
              opacity: 1;
            }
          }
          & > .dot {
            cursor: pointer;
            background-color: #dadada;
            padding-top: 100%;
            border-radius: 50%;
            transition: all 250ms ease-in-out;
            &:first-of-type {
              position: relative;
              left: -0.25rem;
            }
            &:hover,
            &.on {
              background-color: $brn;
            }
          }
          & > .label {
            pointer-events: none;
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translate3d(-50%, 0.125rem, 0);
            white-space: nowrap;
            opacity: 0;
            transition: opacity 250ms ease-in-out;
          }
        }
      }
      &:not(.no-click):hover {
        border-color: $brn;
        transform: scale(1.05);
        z-index: 1;
      }
      &.selected {
        border-color: $brn;
      }
      .stacked-bars {
        display: none;
      }
      &.has-bar {
        padding-left: 0.25rem;
        &.has-filter {
          padding-left: 1rem;
        }
        &:after {
          content: '';
          position: absolute;
          left: 0.25rem;
          right: 0.25rem;
          bottom: 0;
          height: $bar-height;
          background-color: rgba($brn, 0.0625);
          border-radius: $bar-height / 2;
          z-index: -1;
          pointer-events: none;
        }
        > .bar {
          display: block;
          position: absolute;
          left: 0.25rem;
          bottom: 0;
          height: $bar-height;
          max-width: 98%;
          //background-color: rgba($brn, 0.125);
          background-color: orange;
          //border-top: $bar-height solid transparent;
          //border-bottom: $bar-height solid orange;
          border-top-left-radius: $bar-height / 2;
          border-bottom-left-radius: $bar-height / 2;
          border-top-right-radius: $bar-height / 2;
          border-bottom-right-radius: $bar-height / 2;
          //overflow: hidden;
          pointer-events: none;
          //z-index: -1;
          //&:after {
          //  //content: attr(title);
          //  position: absolute;
          //  top: 0;
          //  left: 0.25rem;
          //  color: white;
          //}
        }
        .stacked-bars {
          display: flex;
          position: absolute;
          left: 0.25rem;
          bottom: 0;
          height: $bar-height;
          border-top-left-radius: $bar-height / 2;
          border-bottom-left-radius: $bar-height / 2;
          border-top-right-radius: $bar-height / 2;
          border-bottom-right-radius: $bar-height / 2;
          //overflow: hidden;
          z-index: 10;
          &.has-ref-pub {
            .stacked-bar {
              background-color: #dadada;
              transition: transform 150ms ease-in-out;
              transform-origin: center bottom;
              &.selected {
                background-color: orange;
              }
              &:hover {
                transform: scale(1, 2.5);
              }
            }
          }
          .stacked-bar {
            cursor: pointer;
            //display: inline-block;
            outline: 1px solid white;
            background-color: #9a9a9a;
            height: $bar-height;
          }
        }
        .filter-toggle {
          position: absolute;
          top: 0.3rem;
          left: 0;
          width: 1.2rem;
          height: 1.2rem;
          background: no-repeat center
          url("data:image/svg+xml;charset%3Dutf8,%3C?xml version%3D'1.0' encoding%3D'UTF-8'?%3E%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'-2 -256 1792 1792'%3E%3Cg transform%3D'matrix(1,0,0,-1,182.23729,1201.8983)'%3E%3Cpath style%3D'fill:%238d6e4f;' d%3D'm 1403,1241 q 17,-41 -14,-70 L 896,678 V -64 q 0,-42 -39,-59 -13,-5 -25,-5 -27,0 -45,19 L 531,147 q -19,19 -19,45 V 678 L 19,1171 q -31,29 -14,70 17,39 59,39 h 1280 q 42,0 59,-39 z'/%3E  %3C/g%3E%3C/svg%3E");
          background-size: 75%;
          opacity: 0.5;
          transition: opacity 250ms ease-in-out;
          will-change: opacity;
          &:hover,
          &.selected {
            opacity: 1;
          }
        }
      }
      > .bar {
        display: none;
      }
    }
  }
}
</style>
